import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

import programArtMap from "@/assets/images/user/programArtMap.jpg";
import programArtTab from "@/assets/images/user/programArtTab.svg";
import programArtTabBg from "@/assets/images/user/programArtTabBg.jpg";
import programArtTabBgM from "@/assets/images/user/programArtTabBgM.jpg";
import programArtTabBgT from "@/assets/images/user/programArtTabBgT.jpg";
import programArtTabM from "@/assets/images/user/programArtTabM.svg";
import programArtTabT from "@/assets/images/user/programArtTabT.svg";
import programFestaMap from "@/assets/images/user/programFestaMap.jpg";
import programFestaTab from "@/assets/images/user/programFestaTab.svg";
import programFestaTabBg from "@/assets/images/user/programFestaTabBg.jpg";
import programFestaTabBgM from "@/assets/images/user/programFestaTabBgM.jpg";
import programFestaTabBgT from "@/assets/images/user/programFestaTabBgT.jpg";
import programFestaTabM from "@/assets/images/user/programFestaTabM.svg";
import programFestaTabT from "@/assets/images/user/programFestaTabT.svg";
import programFocusMap from "@/assets/images/user/programFocusMap.jpg";
import programFocusTab from "@/assets/images/user/programFocusTab.svg";
import programFocusTabBg from "@/assets/images/user/programFocusTabBg.jpg";
import programFocusTabBgM from "@/assets/images/user/programFocusTabBgM.jpg";
import programFocusTabBgT from "@/assets/images/user/programFocusTabBgT.jpg";
import programFocusTabM from "@/assets/images/user/programFocusTabM.svg";
import programFocusTabT from "@/assets/images/user/programFocusTabT.svg";
import programPlayMap from "@/assets/images/user/programPlayMap.jpg";
import programPlayTab from "@/assets/images/user/programPlayTab.svg";
import programPlayTabBg from "@/assets/images/user/programPlayTabBg.jpg";
import programPlayTabBgM from "@/assets/images/user/programPlayTabBgM.jpg";
import programPlayTabBgT from "@/assets/images/user/programPlayTabBgT.jpg";
import programPlayTabM from "@/assets/images/user/programPlayTabM.svg";
import programPlayTabT from "@/assets/images/user/programPlayTabT.svg";
import programStageMap from "@/assets/images/user/programStageMap.jpg";
import programStageTab from "@/assets/images/user/programStageTab.svg";
import programStageTabBg from "@/assets/images/user/programStageTabBg.jpg";
import programStageTabBgM from "@/assets/images/user/programStageTabBgM.jpg";
import programStageTabBgT from "@/assets/images/user/programStageTabBgT.jpg";
import programStageTabM from "@/assets/images/user/programStageTabM.svg";
import programStageTabT from "@/assets/images/user/programStageTabT.svg";
import TitleBox from "@/components/user/common/TitleBox";
import ImgZoomPop from "@/components/user/popup/ImgZoomPop";

const tabList = [
    {
        title: "stage",
        link: "/program/stage",
        mobileImg: programStageTabM,
        mobileBg: programStageTabBgM,
        tabletImg: programStageTabT,
        tabletBg: programStageTabBgT,
        desktopBg: programStageTabBg,
        desktopImg: programStageTab,
    },
    {
        title: "play",
        link: "/program/play",
        mobileImg: programPlayTabM,
        mobileBg: programPlayTabBgM,
        tabletImg: programPlayTabT,
        tabletBg: programPlayTabBgT,
        desktopBg: programPlayTabBg,
        desktopImg: programPlayTab,
    },
    {
        title: "art",
        link: "/program/art",
        mobileImg: programArtTabM,
        mobileBg: programArtTabBgM,
        tabletImg: programArtTabT,
        tabletBg: programArtTabBgT,
        desktopBg: programArtTabBg,
        desktopImg: programArtTab,
    },
    {
        title: "focus",
        link: "/program/focus",
        mobileImg: programFocusTabM,
        mobileBg: programFocusTabBgM,
        tabletImg: programFocusTabT,
        tabletBg: programFocusTabBgT,
        desktopBg: programFocusTabBg,
        desktopImg: programFocusTab,
    },
    {
        title: "festa",
        link: "/program/festa",
        mobileImg: programFestaTabM,
        mobileBg: programFestaTabBgM,
        tabletImg: programFestaTabT,
        tabletBg: programFestaTabBgT,
        desktopBg: programFestaTabBg,
        desktopImg: programFestaTab,
    },
];

interface ProgramLayoutProps {
    children: React.ReactNode;
}

export default function ProgramLayout({ children }: ProgramLayoutProps) {
    const location = useLocation();
    const [tabOn, setTabOn] = useState(0);

    useEffect(() => {
        if (location.pathname === "/program/stage") {
            setTabOn(0);
        } else if (location.pathname === "/program/play") {
            setTabOn(1);
        } else if (location.pathname === "/program/art") {
            setTabOn(2);
        } else if (location.pathname === "/program/focus") {
            setTabOn(3);
        } else if (location.pathname === "/program/festa") {
            setTabOn(4);
        }
    }, [location.pathname]);

    return (
        <div className="max-w-[1400px] w-full mx-auto p-[0_20px_120px] md:pb-[160px] xl:px-0">
            <div className="flex flex-col gap-[28px] md:gap-[48px]">
                <TitleBox title="PROGRAM" text="프로그램" />
                <div className="w-[calc(100%+40px)] -ml-[20px] xl:w-full xl:ml-0">
                    <ul className="flex h-[100px]">
                        {tabList.map((tab, index) => (
                            <li
                                key={`tab_${index}`}
                                className={`h-full w-1/5 rounded-[8px_8px_0_0] overflow-hidden ${tabOn === index ? "opacity-100 shadow-[4px_4px_8px_0_rgba(0,0,0,0.25)]" : "opacity-60"}`}
                            >
                                <Link to={tab.link} className="relative flex h-full items-center justify-center">
                                    <img
                                        src={tab.mobileBg}
                                        alt={tab.title}
                                        className="absolute top-0 left-0 w-full h-full object-cover md:hidden"
                                    />
                                    <img src={tab.mobileImg} alt={tab.title} className="relative md:hidden" />
                                    <img
                                        src={tab.tabletBg}
                                        alt={tab.title}
                                        className="absolute top-0 left-0 w-full h-full object-cover hidden md:block xl:hidden"
                                    />
                                    <img
                                        src={tab.tabletImg}
                                        alt={tab.title}
                                        className="relative hidden md:block xl:hidden"
                                    />
                                    <img
                                        src={tab.desktopBg}
                                        alt={tab.title}
                                        className="absolute top-0 left-0 w-full h-full object-cover hidden xl:block"
                                    />
                                    <img src={tab.desktopImg} alt={tab.title} className="relative hidden xl:block" />
                                </Link>
                            </li>
                        ))}
                    </ul>
                    <div
                        className={`p-[20px_0_0] md:p-[28px] md:border-8 md:rounded-[0_0_32px_32px] xl:p-[52px]${tabOn === 0 ? " md:border-[#FF7F71]" : tabOn === 1 ? " md:border-[#00A8A0]" : tabOn === 2 ? " md:border-[#EE4A9B]" : tabOn === 3 ? " md:border-[#F9A643]" : tabOn === 4 ? " md:border-[#209CEF]" : ""}`}
                    >
                        <ImgZoomPop
                            img={
                                tabOn === 0
                                    ? programStageMap
                                    : tabOn === 1
                                      ? programPlayMap
                                      : tabOn === 2
                                        ? programArtMap
                                        : tabOn === 3
                                          ? programFocusMap
                                          : programFestaMap
                            }
                        />
                    </div>
                </div>
            </div>
            {children}
        </div>
    );
}
